<template>
    <div class="renderer-status">
        <div v-if="status !== false">
            Status: {{status.status}}
            <div v-if="status.currentObject !== true && status.currentObject.ID">
                Rendering product : {{status.currentObject.ID}}
            </div>
            <div style="display: none">
                {{status}}
            </div>
        </div>
        <div v-else>
            Status: offline?
        </div>
    </div>
</template>
<script>
    export default {
        name: 'TxRendererStatus',
        data() {
            return {
                status: false,
                interval: 5000,
            }
        },
        watch: {
            interval: {
                handler: function (newValue) {
                    this.restartUpdates(newValue);
                },
                immediate: true,
            }
        },
        created() {
            this.getStatus();
        },
        mounted() {
            document.body.querySelector('#lovemap-status').appendChild(this.$el);
        },
        beforeDestroy() {
            this.$el.remove();
            clearInterval(this._lastInterval);
        },
        methods: {
            restartUpdates(interval) {
                clearInterval(this._lastInterval);
                this._lastInterval = setInterval(this.getStatus, interval);
            },
            async getStatus() {
                try {
                    let {data} = await this.$http({
                        method: 'POST',
                        url: `${lovemap.config.render_url}/api/pdf-render/status`,
                    });

                    this.status = data

                    if (this.interval === 60000){
                        this.interval = 5000;
                    }
                } catch (e) {
                    this.interval = 60000;
                    console.error(e)
                }
            }
        },
    }
</script>
